import React from 'react';
import App from './App';
import AICoaching from './components/AICoaching';
import ProductDetails from './components/ProductDetails';

function Router() {
  const path = window.location.pathname;
  
  switch (path) {
    case '/ai-coaching':
    case '/call-scripts':  // Keep old route for backward compatibility
      return <AICoaching />;
    case '/products':
      return <ProductDetails />;
    default:
      return <App />;
  }
}

export default Router;
